// ─────────────────────────────────────────────────────────────────
// Glass-i — Company Defaults Master API client (Stage 6CM.1).
//
// Thin axios wrappers around /api/erp/company-defaults. Also exposes the
// company-defaults-first effective loader the Proforma editor uses to seed
// a NEW document — it falls back to Proforma Settings (Stage 6Q.3) on any
// failure, so the editor never loses its existing default-loading bridge.
// ─────────────────────────────────────────────────────────────────

import client from '../../../api/client';
import { loadProformaSettingsSafe } from '../masters/proformaSettings/proformaSettingsApi';

const BASE = '/api/erp/company-defaults';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : (resp ? resp.data : null);
}

export const companyDefaultsApi = {
  get:            ()             => client.get(BASE).then(unwrap),
  update:         (payload)      => client.put(BASE, payload).then(unwrap),
  // Stage 6RFQ — company identity (letterhead) for printed documents.
  updateIdentity: (payload)      => client.put(`${BASE}/identity`, payload).then(unwrap),
  reset:          ()             => client.post(`${BASE}/reset`).then(unwrap),
  getDropdowns:   ()             => client.get(`${BASE}/dropdowns`).then(unwrap),
  getEvents:      (params = {})  => client.get(`${BASE}/events`, { params }).then(unwrap),
  getProformaEffective: ()       => client.get(`${BASE}/proforma-effective`).then(unwrap)
};

// Soft-fail dropdown loader — never blocks the page.
export async function loadCompanyDefaultsDropdownsSafe() {
  try { return await companyDefaultsApi.getDropdowns(); }
  catch (_e) { return null; }
}

// Effective defaults for a NEW Proforma: Company Defaults first, falling
// back to the existing Proforma Settings, then safe defaults. The returned
// object is in the Proforma-Settings shape the editor already consumes.
export async function loadProformaEffectiveDefaultsSafe() {
  try {
    const eff = await companyDefaultsApi.getProformaEffective();
    if (eff && typeof eff === 'object') return eff;
  } catch (_e) { /* fall through to the Proforma Settings fallback */ }
  return loadProformaSettingsSafe();
}

export default companyDefaultsApi;
